(() => {
  if (!customElements.get('dt-editorial-disclosures')) {
    customElements.define('dt-editorial-disclosures', class extends HTMLElement {
      connectedCallback() {
        if (this._media || this.dataset.collapseMobile !== 'true') return;
        this._media = window.matchMedia('(max-width: 767px)');
        this._apply = () => {
          this.querySelectorAll('.dt-v2-chapter, .dt-v2-principle').forEach((chapter) => {
            chapter.open = !this._media.matches;
          });
          this._revealHash();
        };
        this._hash = () => this._revealHash();
        this._click = (event) => {
          const link = event.target.closest('a[href^="#"]');
          if (!link) return;
          this._revealHash(link.getAttribute('href'));
        };
        this._select = (event) => {
          if (!this.contains(event.target)) return;
          const chapter = event.target.closest('details');
          if (chapter) chapter.open = true;
        };
        this._apply();
        this._media.addEventListener('change', this._apply);
        window.addEventListener('hashchange', this._hash);
        this.addEventListener('click', this._click);
        this.addEventListener('shopify:block:select', this._select);
      }

      _revealHash(hash = window.location.hash) {
        if (!hash || hash === '#') return;
        let id;
        try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
        const target = document.getElementById(id);
        if (!target || !this.contains(target)) return;
        let chapter = target.matches('details') ? target : target.closest('details');
        while (chapter && this.contains(chapter)) {
          chapter.open = true;
          chapter = chapter.parentElement.closest('details');
        }
      }

      disconnectedCallback() {
        if (!this._media) return;
        this._media.removeEventListener('change', this._apply);
        window.removeEventListener('hashchange', this._hash);
        this.removeEventListener('click', this._click);
        this.removeEventListener('shopify:block:select', this._select);
        this._media = null;
      }
    });
  }

  if (!customElements.get('dt-editorial-toc')) {
    customElements.define('dt-editorial-toc', class extends HTMLElement {
      connectedCallback() {
        const content = document.getElementById(this.dataset.content);
        const list = this.querySelector('ol');
        if (!content || !list || list.childElementCount) return;
        const headings = [...content.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
        if (headings.length < 2) return;
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `${this.dataset.content}-heading-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        this.querySelector('details').open = this.dataset.desktopOpen === 'true'
          && window.matchMedia('(min-width: 768px)').matches;
        this.hidden = false;
      }
    });
  }
})();
